import { edmCampaign } from '@bingads-webui/edm-campaign';

export const fetchCampaignsByIdEDM = ({ cid, aid }, campaignIds) => {
  const formattedCampaignIds = campaignIds.join(', ');
  return edmCampaign
    .Customers.$withKey(cid)
    .Accounts.$withKey(aid)
    .Campaigns
    .get({ filter: { where: `Id in [${formattedCampaignIds}]` } })
    .toPromise();
};
